import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import {
  actions as maintenanceActions,
  fetchMoldMaintenanceWithOpenFilter,
} from './store/slice';
import {
  selectMoldReceivingFilterVisible,
  selectMoldReceivingFilters,
} from './store/selectors';

const { setFilterVisible, setSearchText, setRecordFilter } = maintenanceActions;

const RECORD_FILTER = {
  ALL: 0,
  OPEN: 1,
  WITH_RECORDS: 2, // molds whose latest maintenance Version is CLOSED
};

const MoldMaintenanceSearch = () => {
  const dispatch = useDispatch();
  const filterVisible = useSelector(selectMoldReceivingFilterVisible);
  const { recordFilter } = useSelector(selectMoldReceivingFilters);
  const [searchText, setSearchTextValue] = useState('');

  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextValue(newSearchText);
    dispatch(setSearchText(newSearchText));
  };

  const toggleFilterVisibility = () => {
    const newVisibility = !filterVisible;
    dispatch(setFilterVisible(newVisibility));
  };

  const onRecordFilterChange = filter => {
    dispatch(setRecordFilter(filter));
    dispatch(fetchMoldMaintenanceWithOpenFilter());
  };

  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];

  return (
    <>
      <div className="search-set">
        <div className="search-input">
          <Link to="#" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </Link>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              {' '}
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search"
                aria-controls="DataTables_Table_0"
                value={searchText}
                onChange={handleSearch}
              />
            </label>
          </div>
        </div>
      </div>

      <div className="mold-maint-records-toggle">
        <div className="btn-group" role="group" aria-label="Mold maintenance record filter">
          <input
            type="radio"
            className="btn-check"
            name="moldMaintenanceOpenFilter"
            id="moldMaintOpenRecords"
            checked={recordFilter === RECORD_FILTER.OPEN}
            onChange={() => onRecordFilterChange(RECORD_FILTER.OPEN)}
          />
          <label className="btn btn-outline-primary btn-sm" htmlFor="moldMaintOpenRecords">
            Open Records
          </label>
          <input
            type="radio"
            className="btn-check"
            name="moldMaintenanceOpenFilter"
            id="moldMaintWithRecords"
            checked={recordFilter === RECORD_FILTER.WITH_RECORDS}
            onChange={() => onRecordFilterChange(RECORD_FILTER.WITH_RECORDS)}
          />
          <label className="btn btn-outline-primary btn-sm" htmlFor="moldMaintWithRecords">
            Molds With Records
          </label>
          <input
            type="radio"
            className="btn-check"
            name="moldMaintenanceOpenFilter"
            id="moldMaintAllMolds"
            checked={recordFilter === RECORD_FILTER.ALL}
            onChange={() => onRecordFilterChange(RECORD_FILTER.ALL)}
          />
          <label className="btn btn-outline-primary btn-sm" htmlFor="moldMaintAllMolds">
            All Molds
          </label>
        </div>
      </div>

      <div className="search-path">
        <Link
          to="#"
          className={`btn btn-filter ${filterVisible ? 'setclose' : ''}`}
          id="filter_search"
          onClick={e => {
            e.preventDefault();
            toggleFilterVisibility();
          }}
        >
          <Filter className="filter-icon" />
          <span>
            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
          </span>
        </Link>
      </div>

      <div className="form-sort" style={{ display: 'none' }}>
        <Sliders className="info-img" />
        <Select
          className="img-select"
          classNamePrefix="react-select"
          options={oldandlatestvalue}
          placeholder="Newest"
        />
      </div>
    </>
  );
};

export default MoldMaintenanceSearch;
